import React, { useState } from 'react';
import './HelpSupport.css';

const FAQ = [
  { q:'How do I add a new workflow step?', a:'Open any workflow from the Workflows page, then click the + button between any two steps to add a new action — Create task, Delay, or Branch (If/Then).' },
  { q:'Why can\'t I send marketing emails in workflows?', a:'Your current HubSpot plan requires Marketing Hub Professional to send automated marketing emails. Use the Sequences module for email outreach and the workflow for task-based automation.' },
  { q:'How are scout earnings calculated?', a:'Scouts earn 25% of the net store payment per evaluation. After the 30% store fee: Standard ($10) → scout earns $1.75; Premium ($25) → scout earns $4.38.' },
  { q:'How does club activation work?', a:'A club is considered Activated when they post their first player evaluation request. This triggers the Club Activation workflow automatically via webhook from the backend.' },
  { q:'How do I add contacts to a workflow?', a:'Contacts are enrolled automatically when they match the trigger criteria (e.g. transferexpo_contact_type = Club). Ensure contacts have the correct property set on import.' },
  { q:'What is the activation_status property?', a:'It\'s a custom CRM property set to "Activated" when a club posts their first player request or a scout submits their first evaluation. Used as a workflow trigger and branch condition.' },
];

export default function HelpSupport() {
  const [open, setOpen]     = useState(null);
  const [subject, setSubject]   = useState('');
  const [message, setMessage]   = useState('');
  const [sent, setSent]     = useState(false);

  const send = () => {
    if (!subject || !message) return;
    setSent(true);
    setSubject(''); setMessage('');
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <div className="help-page">
      <div className="two-col">
        {/* FAQ */}
        <div>
          <h3 className="help-section-title">Frequently asked questions</h3>
          <div className="faq-list">
            {FAQ.map((item, i) => (
              <div key={i} className={`faq-item ${open===i?'open':''}`}>
                <button className="faq-q" onClick={() => setOpen(open===i?null:i)}>
                  {item.q}
                  <span className="faq-chevron">{open===i ? '▲' : '▼'}</span>
                </button>
                {open === i && <div className="faq-a">{item.a}</div>}
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="help-section-title">Contact support</h3>
          <div className="card">
            {sent ? (
              <div style={{ textAlign:'center', padding:'24px 0' }}>
                <div style={{ fontSize:36, marginBottom:12 }}>✓</div>
                <div style={{ color:'var(--accent)', fontFamily:'var(--font-display)', fontSize:18, marginBottom:6 }}>Message sent!</div>
                <div style={{ color:'var(--text-muted)', fontSize:13 }}>We'll get back to you within 24 hours</div>
              </div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                  <label style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Subject</label>
                  <input className="search-input" placeholder="What do you need help with?" value={subject} onChange={e => setSubject(e.target.value)} />
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                  <label style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Message</label>
                  <textarea
                    className="search-input"
                    rows={5}
                    placeholder="Describe your issue in detail..."
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    style={{ resize:'vertical', fontFamily:'var(--font-body)' }}
                  />
                </div>
                <button className="btn btn-primary" style={{ alignSelf:'flex-start' }} onClick={send}>Send message</button>
              </div>
            )}
          </div>

          <div className="help-links">
            <h3 className="help-section-title" style={{ marginTop:20 }}>Resources</h3>
            <div className="help-link-grid">
              {[
                { label:'HubSpot Workflow Guide', sub:'How to build and manage workflows' },
                { label:'TransferExpo API Docs', sub:'Webhook events and endpoints' },
                { label:'Revenue Model Breakdown', sub:'Evaluation tiers and payouts' },
                { label:'Playbook PDF', sub:'Full CRM setup and activation guide' },
              ].map((r,i) => (
                <div key={i} className="help-link-card">
                  <div className="help-link-label">{r.label}</div>
                  <div className="help-link-sub">{r.sub}</div>
                  <div style={{ color:'var(--accent)', fontSize:12, marginTop:6 }}>→ Open</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
